import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { logout } from '~/auth/slices/auth.slice'

export interface RedirectionSliceType {
  lockRedirection: boolean
}

const initialState: RedirectionSliceType = {
  lockRedirection: false,
}

const slice = createSlice({
  name: 'redirection',
  initialState,
  reducers: {
    setLockRedirection: (state, action: PayloadAction<RedirectionSliceType['lockRedirection']>) => ({
      ...state,
      lockRedirection: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  },
})

export const selectLockRedirection = (state: RootState): RedirectionSliceType['lockRedirection'] =>
  state.redirection.lockRedirection

export const { setLockRedirection: setLockRedirectionActionCreator } = slice.actions

export default slice.reducer
